import React from 'react';
import SelectCheckbox from '../../../../shared/select-checkbox';
import { ENABLED_FILTERS } from '../../../../utils/constants/enable-filter-values';
import { INVOICES_STATUS } from '../../../../utils/constants/invoices-status';
import Datepicker from '../../../../shared/datepicker';


interface IInvoiceFilters {
    statusFilter?: any;
    dueDateFilter?: any;
    onClickFilter: (value: any, type?: string) => void;
}

const InvoiceFilters = ({
    statusFilter,
    dueDateFilter,
    onClickFilter
}: IInvoiceFilters) => {
    return (
        <div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1 md:gap-4'>
                <SelectCheckbox
                    name='Status'
                    dataQa={'status-filter'}
                    placeholder={''}
                    options={INVOICES_STATUS || []}
                    selectStyle={{ backgroundColor: '#ffffffa4', borderRadius: '4px', minWidth: 200 }}
                    onChangeSelectedOption={onClickFilter}
                    selectedOption={statusFilter}
                    uniqueName={'status'}
                />
                <Datepicker
                    label='Due Date'
                    placeholder=' '
                    containerStyle='mb-0'
                    inputValue={dueDateFilter}
                    onChangeInput={onClickFilter}
                    inputUniqueName={'dueDate'}
                />
            </div>
        </div>
    );
};

export default InvoiceFilters;
